var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnitsColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92181 0C2.71037 0 0.580131 1.51278 0.212417 3.90531C-0.0716342 5.75351 -0.0704854 7.36691 0.213951 9.21923C0.581436 11.6123 2.71097 13.13 4.9266 13.13H9.02688V36.9281C9.02688 40.5539 11.9661 43.4931 15.5919 43.4931H19.7854C19.8591 44.1762 19.9779 44.8756 20.1415 45.6114C20.6402 47.8535 22.6788 49.2375 24.7996 49.2375H44.1158C46.2137 49.2375 48.2379 47.8827 48.7576 45.668C49.3963 42.9462 49.3977 40.7238 48.7604 38.0237C48.2384 35.8122 46.2148 34.4663 44.1244 34.4663H24.794C22.6781 34.4663 20.6397 35.8447 20.1398 38.085C19.9751 38.8229 19.8562 39.5247 19.783 40.2106H15.5919C13.779 40.2106 12.3094 38.741 12.3094 36.9281V25.4394H19.7854C19.8591 26.1225 19.9779 26.8219 20.1415 27.5577C20.6402 29.7998 22.6788 31.1838 24.7996 31.1838H44.1158C46.2137 31.1838 48.2379 29.829 48.7576 27.6143C49.3963 24.8924 49.3977 22.67 48.7604 19.9699C48.2384 17.7584 46.2148 16.4125 44.1244 16.4125H24.794C22.6781 16.4125 20.6397 17.7909 20.1398 20.0312C19.9751 20.7692 19.8562 21.471 19.783 22.1569H12.3094V13.13H16.4036C18.5993 13.13 20.7192 11.6387 21.1049 9.26551C21.4124 7.37364 21.4135 5.73433 21.1075 3.8557C20.7211 1.48355 18.6001 0 16.411 0H4.92181Z",
    fill: "url(#paint0_linear_1013_875)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1013_875",
    x1: 76.812,
    y1: 7.90779,
    x2: 68.6638,
    y2: 62.1374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030AC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitsColored);
export default __webpack_public_path__ + "static/media/units-colored.133b70832e32ab1b788df5b39280450e.svg";
export { ForwardRef as ReactComponent };